// extracted by mini-css-extract-plugin
export var footer = "_p7-0";
export var inherit = "_p7-1";
export var input = "_p7-2";
export var modalContent = "_p7-3";
export var quillEditor = "_p7-4";
export var subtitle = "_p7-5";